/**
 * Compresses an image file to reduce its size while maintaining quality
 * @param {File} file - The image file to compress
 * @param {number} maxSizeKB - Maximum size in KB (default: 1024KB)
 * @returns {Promise<Blob>} - Compressed image as a Blob
 */
export const compressImage = (file, maxSizeKB = 1024) => {
  return new Promise((resolve) => {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const img = new Image();

    img.onload = () => {
      const maxWidth = 800;
      const maxHeight = 600;
      let { width, height } = img;

      if (width > height) {
        if (width > maxWidth) {
          height = (height * maxWidth) / width;
          width = maxWidth;
        }
      } else {
        if (height > maxHeight) {
          width = (width * maxHeight) / height;
          height = maxHeight;
        }
      }

      canvas.width = width;
      canvas.height = height;
      ctx.drawImage(img, 0, 0, width, height);
      let quality = 0.8;
      let compressedDataURL;

      const tryCompress = () => {
        compressedDataURL = canvas.toDataURL("image/jpeg", quality);
        const sizeKB = (compressedDataURL.length * 3) / 4000;

        if (sizeKB > maxSizeKB && quality > 0.1) {
          quality -= 0.1;
          tryCompress();
        } else {
          canvas.toBlob(resolve, "image/jpeg", quality);
        }
      };

      tryCompress();
    };

    img.src = URL.createObjectURL(file);
  });
};
